// extracted by mini-css-extract-plugin
module.exports = {"ichk":"index-module--ichk--XuYPs"};